import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'missions';
const BASE_PATH = `${API_ROOT}/missions`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (missionId) => `${BASE_PATH}/${missionId}`,
    GET: (missionId) => `${BASE_PATH}/${missionId}`,
    LIST: BASE_PATH,
    UPDATE: (missionId) => `${BASE_PATH}/${missionId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(missionId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(missionId)}?${params.toString()}`)).data;
}
function getKey(missionId, props) {
    return [CacheKey, 'get', missionId, props];
}
async function delete_(csrfToken, missionId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(missionId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, missionId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(missionId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
